import { findAndReplace } from '../../../utils/arrayModify';

export function handleCheckin(state, payload) {
  const target = state.list.find(({ id }) => payload.id === id);

  if (target) {
    const { status, allowedActions } = payload;

    return {
      ...state,
      list: findAndReplace(state.list, {
        ...target,
        status,
        allowedActions,
      }),
    };
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/components/Healthboard/utils/handleCheckin.js